import React from 'react';

import InitialLogo from '../logos/InitialLogo';
import AnnualLogo from '../logos/AnnualLogo';

export const PublicNavbar = () => {
  return (
    <header className="Navbar">
      <div className="Navbar__logo">
        <a href={`${process.env.PUBLIC_URL}/../initial/consultant/dashboard`}>
          <InitialLogo />
        </a>
        <a href={`${process.env.PUBLIC_URL}/../annual/consultant/dashboard`}>
          <AnnualLogo />
        </a>
      </div>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/components/navbar/public.js